import { render, staticRenderFns } from "./CvHeader.vue?vue&type=template&id=4c5a01e6"
import script from "./CvHeader.vue?vue&type=script&lang=js"
export * from "./CvHeader.vue?vue&type=script&lang=js"
import style0 from "./CvHeader.vue?vue&type=style&index=0&id=4c5a01e6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports